import React, { useState } from 'react';
import { Select, Row, Col } from 'antd';
import { makeStyles } from '@material-ui/core';
import Modal from '../../component/Modal/Modal';
import InnerHeader from '../../component/InnerHeader';
import PaymentGrid from '../../component/Grid';
import { CStandardInput } from '../../component/Input';
import CButton from '../../component/Button';

const useStyles = makeStyles({
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  }
});

const PaymentMethod = () => {
  const [selected, setSelected] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [openNewContentModelModal, setOpenNewContentModelModal] = useState(false);

  const classes = useStyles();
  const [acc, setAcc] = useState([
    {
      accNum: '72472934941234',
      default: true,
      expires: '03/24',
      id: '1',
      title: 'Card1',
      type: 'visa'
    },
    {
      accNum: 'u3434341234',
      default: false,
      expires: '03/24',
      id: '2',
      title: 'Card2',
      type: 'mastercard'
    }
  ]);

  const onNewContentModel = () => {
    setOpenNewContentModelModal(true);
  };

  const onNewContentModelCancel = () => {
    setOpenNewContentModelModal(false);
  };

  const selectAcc = () => {
    if (!selected) {
      return;
    }
    // making all accounts to have "default: false"
    const newArr = [];
    acc.forEach((item) => {
      item.default = false;
      newArr.push(item);
    });
    setAcc(newArr);

    // in order to choose the selected account and make it have "default: true"
    const updatedArr = [];
    acc.forEach((i) => {
      if (i.id === selectedId) {
        i.default = true;
        updatedArr.push(i);
      } else {
        updatedArr.push(i);
      }
    });

    setAcc(updatedArr);
  };

  // const openDetail = (item, index) => {
  //   return () => {
  //     history.push({
  //       pathname: `/payment-method/${item.accNum}`,
  //     });
  //   };
  // };

  const actions = [
    { title: 'Delete', type: 'default' },
    { onClick: selectAcc, title: 'Make Default', type: 'default' },
    {
      onClick: onNewContentModel,
      title: 'Add Payment Method',
      type: 'primary'
    }
  ];

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader actions={actions} title="Payment Method" />

      <Modal
        footerActions={
          <>
            <CButton
              htmlType="submit"
              onClick={(e) => {
                setOpenNewContentModelModal(false);
                e.preventDefault();
              }}
              size="large"
              type="secondary"
            >
              Cancel
            </CButton>
            <CButton
              htmlType="submit"
              size="large"
              type="primary"
              // onClick={(e) => onSave(e)}
              // disabled={!isSaveEnabled}
            >
              Update Record
            </CButton>
          </>
        }
        handleClose={onNewContentModelCancel}
        isModalOpen={openNewContentModelModal}
        styles={{
          '& .MuiDialogContent-root': {
            paddingTop: '0px'
          },
          width: '400px'
        }}
        titleContent={<h2 className="modal-title">Add Payment Method</h2>}
      >
        <form
          id="new-content-model-form"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px'
          }}
        >
          <CStandardInput
            allowClear
            disableUnderline
            formClasses={{ root: classes.root }}
            htmlFor="standard-input-credit-card-number"
            id="standard-input-credit-card-number"
            label="Credit Card Number"
            size="large"
            // onChange={(event) =>
            //   setDraft({ ...customTypeDraft, name: event.target.value })
            // }
          />

          <Row align="bottom" justify="space-between" style={{ width: '100%' }}>
            <Col>
              <CStandardInput
                allowClear
                disableUnderline
                formClasses={{ root: classes.root }}
                htmlFor="standard-input-credit-card-month-year"
                id="standard-input-credit-card-month-year"
                label="MM / YY"
                size="large"
                // onChange={(event) =>
                //   setDraft({ ...customTypeDraft, name: event.target.value })
                // }
              />
            </Col>
            <Col>
              <CStandardInput
                allowClear
                disableUnderline
                formClasses={{ root: classes.root }}
                htmlFor="standard-input-credit-card-cvc"
                id="standard-input-credit-card-cvc"
                label="CVC"
                size="large"
                // onChange={(event) =>
                //   setDraft({ ...customTypeDraft, name: event.target.value })
                // }
              />
            </Col>
          </Row>
          <CStandardInput
            allowClear
            disableUnderline
            formClasses={{ root: classes.root }}
            htmlFor="standard-input-credit-card-name"
            id="standard-input-credit-card-name"
            label="Name on the Credit Card"
            size="large"
            // onChange={(event) =>
            //   setDraft({ ...customTypeDraft, name: event.target.value })
            // }
          />

          <Select defaultValue="Country" style={{ marginTop: '5px', width: '100%' }}>
            {/* <Option value="jack">Country</Option> */}
          </Select>

          <CStandardInput
            allowClear
            disableUnderline
            formClasses={{ root: classes.root }}
            htmlFor="standard-input-address-line-one"
            id="standard-input-address-line-one"
            label="Address Line 1"
            size="large"
            // onChange={(event) =>
            //   setDraft({ ...customTypeDraft, name: event.target.value })
            // }
          />

          <CStandardInput
            allowClear
            disableUnderline
            formClasses={{ root: classes.root }}
            htmlFor="standard-input-address-line-two"
            id="standard-input-address-line-two"
            label="Address Line 2"
            size="large"
            // onChange={(event) =>
            //   setDraft({ ...customTypeDraft, name: event.target.value })
            // }
          />
          <Row align="bottom" justify="space-between" style={{ width: '100%' }}>
            <Col>
              <CStandardInput
                allowClear
                disableUnderline
                formClasses={{ root: classes.root }}
                htmlFor="standard-input-city"
                id="standard-input-city"
                label="City"
                size="large"
                // onChange={(event) =>
                //   setDraft({ ...customTypeDraft, name: event.target.value })
                // }
              />
            </Col>
            <Col>
              <CStandardInput
                allowClear
                disableUnderline
                formClasses={{ root: classes.root }}
                htmlFor="standard-input-zip-code"
                id="standard-input-zip-code"
                label="ZIP Code"
                size="large"
                // onChange={(event) =>
                //   setDraft({ ...customTypeDraft, name: event.target.value })
                // }
              />
            </Col>
          </Row>
        </form>
      </Modal>

      <PaymentGrid data={acc} updateSelected={setSelected} updateSelectedId={setSelectedId} />
    </div>
  );
};

export default PaymentMethod;
